<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.NAME')">
          <b-form-input
            v-model="form.name"
            :state="getState('name')"
            required
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.BULSTAT')">
          <b-form-input v-model="form.bulstat" :state="getState('bulstat')" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.VAT_NUMBER')">
          <b-form-input
            v-model="form.vatNumber"
            :state="getState('vatNumber')"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.MOL_NUMBER')">
          <b-form-input
            v-model="form.molNumber"
            :state="getState('molNumber')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.ADDRESS')">
          <b-form-input v-model="form.address" :state="getState('address')" />
        </b-form-group>
      </b-col>
      <b-col md="2" class="d-flex align-items-center">
        <b-form-group :label="$t('FORM_LABELS.IS_CONFIRMED')" class="w-100">
          <b-form-checkbox switch v-model="form.isConfirmed" />
        </b-form-group>
      </b-col>
      <b-col md="2" class="d-flex align-items-center">
        <b-form-group :label="$t('FORM_LABELS.IS_BUYER')" class="w-100">
          <b-form-checkbox switch v-model="form.isBuyer" />
        </b-form-group>
      </b-col>
      <b-col md="2" class="d-flex align-items-center">
        <b-form-group :label="$t('FORM_LABELS.IS_SUPPLIER')" class="w-100">
          <b-form-checkbox switch v-model="form.isSupplier" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <slot name="actions"></slot>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
export default {
  name: "AiCompanyForm",
  props: {
    form: { type: Object, required: true },
    errors: { type: Array, default: () => [] },
    $v: { type: Object, default: null }
  },
  methods: {
    getState(field) {
      if (!this.$v || !this.$v.form || !this.$v.form[field]) return null;
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$emit("submit");
    }
  }
};
</script>
